import { useMetricsList } from "@/metrics/catalog"
import type { MetricRecord } from "@/metrics/runtime"

type MetricsData = Record<string, MetricRecord>

interface UseAllMetricsOptions<T> {
  enabled?: boolean
  metricNames?: string[]
  select?: (data: MetricsData) => T
  tagFilters?: string[]
}

/**
 * Unified hook for fetching all uploaded conversation metrics.
 * Uses React Query caching to share data across all consumers.
 *
 * This hook replaces individual getAllMetrics calls in:
 * - ConversationsFilterChips.tsx
 * - ConversationsFilterDropdown.tsx
 */
export const useAllMetrics = <T = MetricsData>(
  options?: UseAllMetricsOptions<T>,
) => {
  return useMetricsList<T>(options)
}
